
















import Vue from 'vue';
import Component from 'vue-class-component';

import MainContents from "./mainContents/mainContents.vue"
import LoadingAnimationStartUp from "./loadingAnimationStartUp/loadingAnimationStartUp.vue"
import Startup from "./startup/startup.vue"
import LoadingScreen from "./loadingScreen/loadingScreen.vue"
import AlertModal from "@/commonComponents/alertModal/alertModal.vue";
import WebfontRenderer from './webfontRenderer/webfontRenderer.vue';

import { UserAgentHelper } from "@/helper/userAgentHelper";
import { DebugHelper } from '@/helper/debugHelper';

@Component({
  components: {
      MainContents,
      LoadingAnimationStartUp,
      Startup,
      LoadingScreen,
      AlertModal,
      WebfontRenderer
  }
})
export default class Top extends Vue
{
    private isStartupCompleted = false;
    private isLoadingScreenVisible = false;
    private destroyLoadingTimeoutId : number | null = null;
    private isFileErrorModalVisible = false;

    private get loadingMessage() { return UserAgentHelper.isMobile() ? "" : "now loading..."; }

    private get fileErrorTitle() { return "ファイルを開くことができません"; }
    private get fileErrorMessage() { return "ファイルが破損しているか、拡張子がファイル形式と一致していない可能性があります。"; }

    mounted()
    {
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.subscribe(this, "opening_project_file", this.onOpeningProjectFile)
    }

    destroyed()
    {
        // メッセージセンター削除
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.unsubscribe(this, "opening_project_file");

        // ファイル読み込み中モーダルのキャンセル
        this.destroyLoadingScreen();
    }

    private showLoadingScreen()
    {
        // ファイル読み込み中モーダルを表示する
        this.isLoadingScreenVisible = true;
        // 万が一エラーがあって永久に解消できないと困るので、強制的に1分後に非表示にする
        this.destroyLoadingTimeoutId = setTimeout(() =>
        {
            this.isLoadingScreenVisible = false;
        }, 60 * 1000);
    }

    private destroyLoadingScreen()
    {
        this.isLoadingScreenVisible = false;
        if(this.destroyLoadingTimeoutId != null)
        {
            clearTimeout(this.destroyLoadingTimeoutId);
            this.destroyLoadingTimeoutId = null;
        }
    }

    public showFileErrorMessage()
    {
        this.isFileErrorModalVisible = true;
    }

    public destoryFileErrorMessage()
    {
        this.isFileErrorModalVisible = false;
    }

    private onOpeningProjectFile()
    {
        DebugHelper.trace("ファイル読み込み中");
        this.showLoadingScreen();
    }

    private get hasSplash(): boolean
    {
        // モバイルは表示しない
        if(UserAgentHelper.isMobile()) { return false; }

        return process.env.VUE_APP_LOGO_SPLASH === 'yes';
    }

    private get isSplashEnded(): boolean
    {
        // 状態を保存して、新しく開いた時だけ再生する
        return this.$store.state.isSplashEnded;
    }

    private get canSplashSkip(): boolean
    {
        // 読み込みが終わったらスキップできる
        // なぜか完了時にfalse
        return !this.$store.getters.data.isLoadAllVisibleProduct;
    }

    private get isLoading(): boolean
    {
        if (!this.canSplashSkip) {
            // データの読み込み中は常に待たないとTemplateなどの動作がおかしくなる
            return true;
        }
        return this.hasSplash && !this.isSplashEnded;
    }

    private onStartupCompleted(to : string | null)
    {
        // クエリ対応
        if(to != null)
        {       
            this.$router.push(to);
        }
        else
        {
            this.isStartupCompleted = true; 
        }
    }

    private hideSplash()
    {
        this.$store.commit('stopSplash');
    }
}
